(function ($) {
    $.fn.deviceSelector = function (val, params) {
        $(this).each(function () {
            var elm = $(this);

            elm.attr('data-search-type', 'device');


            const onChange = function (obj) {
                if (typeof obj == 'string') {
                    obj = JSON.parse(obj);
                }
                elm.removeClass('has-special-selector').deviceSelector(obj.id, params);
            };

            elm.specialSelector({
                val: val,
                option: function (row) {
                    return '<option value="' + row.id + '">' + row.description + '</option>';
                },
                addNew: function () {
                    const type = elm.attr('data-device-type');
                    const id = elm.attr('data-device-owner-id');
                    add_device(type, id, onChange, params ? params.onOpen : undefined);
                }.bind([elm]),
                onOpen: function (id) {
                    view_device(id, {
                        callback: function (obj, elm, popup) {
                            onChange(obj);
                            popup.close();
                        }
                    });
                }
            });
        });
        return this;
    };

}(jQuery));